/**
 * FERP Portal - Resource List Page (DRR-074: Tabulator DRY Template)
 *
 * OPTIMIZE Phase: Resource allocation and capacity planning.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function ResourceListPage() {
  return <TabulatorPrimitiveManager primitiveType="resource" />;
}

export default ResourceListPage;
